"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const FinishScreenWeb_1 = __importDefault(require("../common/FinishScreenWeb"));
const OfferFlightSuccessWeb = () => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    return ((0, jsx_runtime_1.jsx)(FinishScreenWeb_1.default, { type: "Success", title: t("success_info_page.success"), subtitle: t("success_info_page.offer_sent_message"), showMyFlightsBtn: true }));
};
exports.default = OfferFlightSuccessWeb;
